import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router';
// mui
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { Button, Container } from '@mui/material';
// component
import SFCopyIcon from '@/component/icons/sf-copy-icon';
import TopBackButton from '@/component/common/top-back-button';
import BottomFix from '@/component/common/bottom-fix';
// hook
import { useWeb3 } from '@/hooks/use-web3';
// api
import ErrorRes from '@/api/server/ErrorRes';
// lib & store
import { SFPalette } from '@/lib/color';
import { CutStringTo0x, ShortenAddr } from '@/lib/Shorten';
import { useSendNftInfoActions, SendNftState } from '@/store/zustand/store';
import { copy } from '@/lib/util';
import { Nft } from 'alchemy-sdk';

export default function NFTDetail() {
  const {
    state: { contract, tokenId },
  } = useLocation();
  const { t } = useTranslation();
  const [data, setData] = useState<Nft>();
  const navigate = useNavigate();
  const { setSendNftInfo } = useSendNftInfoActions();
  const { web3authCall } = useWeb3();

  useEffect(() => {
    console.log(contract);
    console.log(tokenId);
    if (!contract || !tokenId) {
      // 리스트로 뒤로 가기
    }
    (async () => {
      const payload = {
        contract,
        tokenId,
      };
      if (!web3authCall?.connected()) {
        // TODO 리스트로 뒤로 가기
      }
      const re = await web3authCall?.getAlchemy().nftMetadata(contract, tokenId);
      if (!re) {
        return;
      }
      console.log(re);
      setData(re);
      // const re = await nftDetail(payload);
      // if (re.status !== 200 || re.data.status !== 200) {
      //   ErrorRes({ code: re.data.status, msg: t('message.unableLoadPage') });
      //   return;
      // }
    })();
  }, [contract, tokenId]);

  if (!contract && !tokenId) return null;
  if (!data) {
    return <></>;
  }
  return (
    <>
      <Box
        position="absolute"
        top={120}
        // left={0}
        // right={0}
        // display={true ? 'block' : 'none'}
        zIndex={1500}
        width="100%"
        maxWidth={480}
      ></Box>

      <Box
        sx={{
          position: 'relative',
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            minHeight: 812,
            position: 'relative',
          }}
        >
          <TopBackButton
            title="NFT 상세"
            boxProps={{
              mb: 4,
            }}
            backPath="/nft"
          />
          <Box px={3} width="100%" textAlign="center">
            <img src={data.image?.cachedUrl} alt={data.contract.name} width="100%" />
          </Box>
          {/* <IconButton onClick={onClose} sx={{ position: 'absolute', right: 0, top: 0, p: 0 }}>
          <Close />
        </IconButton> */}
          <Box mb={3} />
          <Box>
            <Typography variant="h5" fontWeight={700} mb={3}>
              {t('validation.detailInfo')}
            </Typography>
            <Box>
              <Typography variant="subtitle2" mb={1}>
                {t('validation.explanation')}
              </Typography>
              <Typography variant="body1" fontWeight={500} color={SFPalette.grey4}>
                {data.description}
              </Typography>
            </Box>
            <Divider
              sx={{
                my: 3,
              }}
            />
            <Box>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2" mb={1}>
                  {t('validation.tokenNum')}
                </Typography>
                <Typography variant="body1" fontWeight={500} color={SFPalette.grey4}>
                  {data.tokenId}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2" mb={1}>
                  {t('validation.contractAddress')}
                </Typography>
                <Typography variant="body1" fontWeight={500} color={SFPalette.grey4}>
                  {ShortenAddr(data.contract.address)}
                  <IconButton
                    sx={{
                      p: 0.5,
                    }}
                    onClick={() => {
                      console.log(data.contract.address);
                      copy(String(data.contract.address));
                      // navigator.clipboard.writeText(String(data.contract));
                      toast.success(`${t('toast.copyYourWallet')}`);
                    }}
                  >
                    <SFCopyIcon color={'black'} />
                  </IconButton>
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <BottomFix enableHeight={false}>
                  <Button
                    onClick={() => {
                      const payload: SendNftState = {
                        fromAddr: null,
                        toAddr: null,
                        contract: CutStringTo0x(data.contract.address),
                        tokenId: data.tokenId,
                        tokenType: data.tokenType,
                      };
                      setSendNftInfo(payload);
                      navigate('/sendNft');
                    }}
                    fullWidth
                    size="large"
                    variant="contained"
                  >
                    {t('button.sendNft')}
                  </Button>
                </BottomFix>
              </Stack>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}
